import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgDataStoryNodeCard } from "../../../molecules/KgDataStoryNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const DataStoryFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgDataStoryNodeCard
      name={data.title ?? ""}
      status={data.status}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default DataStoryFlowNode;
